<template>
	<div class="shop_index">
		<topbar></topbar>
		<div class="clear"></div>
		<!--店铺banner 开始-->
		<div class="hq-shop-banner" v-if="bannerItem!=''">
			<img v-bind:src="bannerItem.mediaCode" style="width:1400; height:120px;cursor:pointer;" @click="goUrl(bannerItem.link)" />
		</div>
		<!--店铺banner 结束-->
		<!--店铺导航 开始-->
		<div class="hq-shop-header">
			<div class="w1200 bc bd">
				<ul class="hq-shop-nav">
					<li class="hover">
						<a href="#">Home</a>
					</li>

					<!--					<li class="all-goods pr" v-on:mouseenter="goodsCateShow()" v-on:mouseleave="goodsCateHidden()">
						<router-link :to="{path:'/shop_goods_list'}">全部商品<i class="dp-ico-a-1"></i></router-link>
						<ol class="categorys-dropdown none">
							<li v-for="catBo in firstCatList">
								<router-link :to="{path:'/shop_goods_list',query:{catCode:catBo.catCode,shopCode:shopCode}}">{{catBo.catNameCn}}</router-link>
							</li>
						</ol>
					</li>-->
					<li>
						<a @click="goShopIntroduction()">Company Profile</a>
					</li>
				</ul>
				<div class="hq-shop-zx fr">
					<a class="a-btn-zx" href="javascript:void(0);" v-on:mouseenter="shopAskAndFavoriteShow()">Consulting/collection<i class="dp-ico-a-1"></i></a>
					<div class="zx-drop-box none" v-on:mouseleave="shopAskAndFavoriteHidden()">
						<div class="item-1">
							<i class="dp-ico-arrw"></i>

							<p>Shop favorable rate：{{goodRate}}%</p>

							<p v-if="shopBo.creditPoint>=4">
								<span class="vm">Credit rating： </span>
								<span v-if="shopBo.creditPoint>=4&&shopBo.creditPoint<=10" class="vip_rank_1 vm"></span>
								<span v-if="shopBo.creditPoint>=11&&shopBo.creditPoint<=40" class="vip_rank_2 vm"></span>
								<span v-if="shopBo.creditPoint>=41&&shopBo.creditPoint<=90" class="vip_rank_3 vm"></span>
								<span v-if="shopBo.creditPoint>=91&&shopBo.creditPoint<=150" class="vip_rank_4 vm"></span>
								<span v-if="shopBo.creditPoint>=151&&shopBo.creditPoint<=250" class="vip_rank_5 vm"></span>
								<span v-if="shopBo.creditPoint>=251&&shopBo.creditPoint<=500" class="vip_rank_6 vm"></span>
								<span v-if="shopBo.creditPoint>=501&&shopBo.creditPoint<=1000" class="vip_rank_7 vm"></span>
								<span v-if="shopBo.creditPoint>=1001&&shopBo.creditPoint<=2000" class="vip_rank_8 vm"></span>
								<span v-if="shopBo.creditPoint>=2001&&shopBo.creditPoint<=5000" class="vip_rank_9 vm"></span>
								<span v-if="shopBo.creditPoint>=5001&&shopBo.creditPoint<=10000" class="vip_rank_10 vm"></span>
								<span v-if="shopBo.creditPoint>=10001&&shopBo.creditPoint<=20000" class="vip_rank_11 vm"></span>
								<span v-if="shopBo.creditPoint>=20001&&shopBo.creditPoint<=50000" class="vip_rank_12 vm"></span>
								<span v-if="shopBo.creditPoint>=50001&&shopBo.creditPoint<=100000" class="vip_rank_13 vm"></span>
								<span v-if="shopBo.creditPoint>=100001&&shopBo.creditPoint<=200000" class="vip_rank_14 vm"></span>
								<span v-if="shopBo.creditPoint>=200001" class="vip_rank_15"></span>
							</p>
						</div>
						<div class="item-2">
							<a class="a-btn-zxzx" :href="shopBo.qq"><i class="dp-ico-zxzx"></i>Online consultation</a>
							<a class="a-btn-scbd ml10" v-on:click="addOrDeleteFavoriteShop()"><i class="dp-ico-scbd"></i>{{ isExistFavoriteShop==0? 'Favorites' : 'Already collected' }}</a>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!--店铺导航 结束-->
		<!--轮播开始-->
		<div class="shop-focus-img" v-if="sliderItems!=''">
			<mt-swipe :auto="3000" :speed="1000" style="height:370px;cursor:pointer;">
				<!--@click不起作用添加，原始的onclick事件，定义在index.html中-->
				<mt-swipe-item v-for="(i, index) in sliderItems" v-bind:link="i.link" onclick="jumpUrl(this)" @click="goUrl(i.link)" :key="index" :style="{background: 'url(' + i.mediaCode + ')'+'no-repeat center top'}">
					<a style="display: none;">{{i.link}}</a>
				</mt-swipe-item>
			</mt-swipe>
		</div>
		<!--轮播结束-->

		<div class="w1200 bc" style="margin-bottom: 20px;">
			<!--音像专区 开始-->
			<div v-if="noGoods" class="qidai"></div>

			<!-- huangqiao放个更多跳转到搜索页带上店铺参数 -->
			<div class="shop-tabbox-1 shop-jp-tj" v-for="(shopCatBo,index) in firstCatList" v-if="shopCatBo.goodsList.length!=0">
				<div class="hd">
					<ul>
						<li class="hover">
							<a @click="getCatGoods('',shopCatBo.catCode)">{{shopCatBo.catNameCn}}</a>
						</li>
						<ul class="tags">
							<a class="more" @click="getMore(shopCatBo.catCode,shopCatBo.catNameCn)">more ></a>
							<li v-for="childCatBo in shopCatBo.childCatList">
								<a href="javascript:void(0);" @click="getCatGoods(childCatBo.catCode,shopCatBo.catCode)">{{childCatBo.catNameCn}}</a>
							</li>
						</ul>
					</ul>
				</div>
				<!--huangqiao每种商品：限制8个  没有商品的类别不要显示  -->
				<div class="bd" v-if="shopCatBo.catCode != 'spike'">
					<ul :id="shopCatBo.catCode">
						<li v-for="(goodsBo,index) in shopCatBo.goodsList" v-if="index<8">
							<p class="pic tc">
								<a @click="goDetail(goodsBo.goodsCode)"><img :src="profixPath+(goodsBo.imgMiddle!=null?(goodsBo.imgMiddle.split(';'))[0]:'')" width="265" height="265"></a>
							</p>
							<p class="title">
								<a @click="goDetail(goodsBo.goodsCode)">{{goodsBo.goodsNameEn}}</a>
							</p>
							<p class="other" v-if="goodsBo.goodsPrice==0">
								<span class="price">¥{{goodsBo.unitPrice/100}}</span>
							</p>
							<p class="other" v-else>
								<span class="price">
								{{goodsBo.goodsPrice}}
									<span v-if="goodsBo.pointType == 'point'">point</span>
									<span v-else-if="goodsBo.pointType == 'special'">special point</span>
									<span v-else-if="goodsBo.pointType == 'red'">red point</span>
									<span v-else-if="goodsBo.pointType == 'blue'">blue point</span>
								</span>
							</p>

						</li>
					</ul>
				</div>
				<div class="bd" v-if="shopCatBo.catCode == 'spike'">
					<ul :id="shopCatBo.catCode" class="miaosha-ul">
						<li v-for="goodsBo in shopCatBo.goodsList">
							<p class="pic tc">
								<a @click="goDetail(goodsBo.goodsCode)"><img :src="profixPath+goodsBo.imgMiddle" width="265" height="265"></a>
							</p>
							<p class="title">
								<a @click="goDetail(goodsBo.goodsCode)">{{goodsBo.goodsNameEn}}</a>
							</p>
							<div class="line-price"><span class="co3">¥{{goodsBo.unitPrice/100}}</span><span class="old">¥{{goodsBo.marketPrice/100}}</span></div>
							<div class="pinpainow_item_time">
								<span class="brandsknow_time_txt" v-if="goodsBo.saleStatus==='end'">                         
                				over                       
                			</span>
								<span class="brandsknow_time_txt" v-if="goodsBo.saleStatus==='wait_start'">                         
                				From the beginning <i class="brandsknow_time_txt_time">{{goodsBo.hour}}</i>hours<i class="brandsknow_time_txt_time">{{goodsBo.minute}}</i>minutes<i class="brandsknow_time_txt_time">{{goodsBo.second}}</i>seconds                  
                			</span>
								<span class="brandsknow_time_txt" v-if="goodsBo.saleStatus==='on_sale'">                         
                				End of distance <i class="brandsknow_time_txt_time">{{goodsBo.hour}}</i>hours<i class="brandsknow_time_txt_time">{{goodsBo.minute}}</i>minutes<i class="brandsknow_time_txt_time">{{goodsBo.second}}</i>seconds                        
                			</span>
							</div>
						</li>
					</ul>
				</div>
				<div class="mt20" v-if="index == 0&&adsItem!=''">
					<a :href="adsItem.link"><img :src="adsItem.mediaCode" width="1200" height="390"></a>
				</div>

			</div>
		</div>
		<!--container 结束-->
		<div style="padding-bottom: 0.8rem;width: 1200px;margin: auto;" v-if="bottomAdsItem!=''">
			<a :href="bottomAdsItem.link">
				<img :src="bottomAdsItem.mediaCode" width="1200" height="60"></img>
			</a>
		</div>
		<footermenu></footermenu>
		<footercopyright></footercopyright>

	</div>
</template>
<script>
</script>
<script>
	/*引入Vue框架*/
	import Vue from 'vue'
	/*引入资源请求插件*/
	import VueResource from 'vue-resource'
	/*使用VueResource插件*/
	Vue.use(VueResource)
	import TopBar from '@/components/TopBar'
	import EmallHeader from '@/components/EmallHeader'
	import FooterMenu from '@/components/FooterMenu'
	import FooterCopyright from '@/components/FooterCopyright'
	//import jQuery from "../../../static/js/jquery.min.js"
	import jQuery from 'jquery';
	import { getImgUrl, getAjaxUrl } from "../../../static/js/emallUtils.js"
	import alertConfirm from "../../../static/js/alertConfirm.js"
	import { Swipe, SwipeItem } from 'mint-ui';
	import API from "../../../static/api/api.js"
	Vue.component(Swipe.name, Swipe);
	Vue.component(SwipeItem.name, SwipeItem);

	export default {
		name: 'shop_index',
		data() {
			return {
				tea: [],
				wine: [],
				shopBo: {},
				sliderItems: [],
				bannerItem: '',
				adsItem: '',
				bottomAdsItem: '',
				sliderHeight: '370px',
				shopCatList: '',
				shopCode: '',
				catCode: 'categoryAll',
				interval: 'intervalAll',
				sortTime: 'timeAll',
				currentPage: 1,
				totalPage: 1,
				orderBy: '',
				orderAsc: '',
				firstCatList: [],
				profixPath: '',
				isExistFavoriteShop: 0,
				linkList: [],
				goodRate: '',
				computeFlag: '',
				noGoods: false
			}
		},
		components: {
			'topbar': TopBar,
			'emallheader': EmallHeader,
			'footermenu': FooterMenu,
			'footercopyright': FooterCopyright
		},
		methods: {
			goUrl: function(url) {
				var currentUrl = window.location.href;
				if(currentUrl.split("?")[0] == url.split("?")[0]) {
					window.location.href = url;
					window.location.reload();
				} else {
					window.location.href = url;
				}
			},
			getCatGoods: function(childCatCode, firstCatCode) {
				var that = this;
				var parentCode = "";
				if(childCatCode == "") {
					parentCode = firstCatCode;
				}
				API.getShopGoodsByCat(that.shopCode, childCatCode, parentCode, function(ret) {
					var goodsShopBos = ret.data.goodsShopBos;
					var vhtml = "";
					if(goodsShopBos != undefined) {
						for(var i = 0; i < goodsShopBos.length; i++) {

							//商品图片
							var imgMiddle = goodsShopBos[i].imgMiddle; // 图片
							if(imgMiddle.indexOf(";") != -1) {
								imgMiddle = imgMiddle.split(";")[0];
							}
							imgMiddle = getImgUrl() + "/upload/show.htm?filePath=" + imgMiddle;
							goodsShopBos[i].imgMiddle = imgMiddle;
							goodsShopBos[i].unitPrice = goodsShopBos[i].unitPrice / 100;

							vhtml += "<li>";
							vhtml += "<p class='pic tc'>";
							vhtml += "<a href='#goodsDetails?goodsCode=" + goodsShopBos[i].goodsCode + "'><img src='" + goodsShopBos[i].imgMiddle + "' width='265' height='265'></a>";
							vhtml += "</p>";
							vhtml += "<p class='title'>";
							vhtml += "<a href='#goodsDetails?goodsCode=" + goodsShopBos[i].goodsCode + "'>" + goodsShopBos[i].goodsNameEn + "</a>";
							vhtml += "</p>";
							vhtml += "<p class='other'>";
							vhtml += "<span class='price'>¥" + goodsShopBos[i].unitPrice + "</span>";
							vhtml += "</p>";
							vhtml += "</li>";
						}
					}
					//						jQuery("#"+firstCatCode).html(vhtml);
					jQuery("#" + firstCatCode).html(vhtml);
				});
			},
			goDetail: function(goodsCode) {
				this.$router.push({
					name: 'goodsdetail',
					query: {
						goodsCode: goodsCode
					}
				});
			},
			goShopIntroduction: function() {
				this.$router.push({
					name: 'shopIntroduction',
					query: {
						shopCode: this.shopCode
					}
				});
			},
			goodsCateShow: function() {
				$(".categorys-dropdown").show();
			},
			goodsCateHidden: function() {
				$(".categorys-dropdown").hide();
			},
			shopAskAndFavoriteShow: function() {
				$(".zx-drop-box").show();
			},
			shopAskAndFavoriteHidden: function() {
				$(".zx-drop-box").hide();
			},
			getShopInfo: function() {
				var that = this;
				var shopCode = that.shopCode;
				this.$http.jsonp(getAjaxUrl() + "/shop/ajax_shop.json", {
					params: {
						shopCode: shopCode
					},
					jsonp: 'callback'
				}).then(function(res) {
					if(res.body.code == "success") {

						var shopBo = res.body.data.shopBo;
						var goodRate = res.body.data.goodRate;
						if(goodRate != undefined) {
							that.goodRate = goodRate;
						}
						//alert(shopBo.creditPoint);
						if(shopBo != undefined) {
							var qq = shopBo.qq;
							if(qq != undefined && qq != '') {
								shopBo.qq = 'http://wpa.qq.com/msgrd?v=3&site=qq&menu=yes&uin=' + qq;
							}
						}
						that.shopBo = shopBo;

						var linkList = res.body.data.linkList;
						if(linkList != undefined) {
							for(var i = 0; i < linkList.length; i++) {
								linkList[i].mediaCode = getImgUrl() + "/upload/show.htm?filePath=" + linkList[i].mediaCode;
							}
							that.linkList = linkList;
						}

						var firstCatList = res.body.data.firstCatList;
						if(firstCatList != undefined) {
							that.firstCatList = firstCatList;
							if(firstCatList.length == 0) {
								that.noGoods = true;
							}
							for(var i = 0; i < firstCatList.length; i++) {
								if(firstCatList[i].catCode == 'spike') {
									for(var j = 0; j < firstCatList[i].goodsList.length; j++) {

										var marketPrice = JSON.parse(firstCatList[i].goodsList[j].attrValue).marketPrice;
										var saleTimeStr = JSON.parse(firstCatList[i].goodsList[j].attrValue).saleTimeShow;
										var saleEndTimeStr = JSON.parse(firstCatList[i].goodsList[j].attrValue).saleEndTimeShow;
										if(marketPrice != undefined && marketPrice != "") {
											firstCatList[i].goodsList[j].marketPrice = marketPrice;
										} else {
											firstCatList[i].goodsList[j].marketPrice = firstCatList[i].goodsList[j].unitPrice;
										}
										if(saleEndTimeStr != undefined && saleEndTimeStr != '') {
											saleEndTimeStr = saleEndTimeStr.replace(/-/g, "/");
											var saleEndDate = new Date(saleEndTimeStr);

											saleTimeStr = saleTimeStr.replace(/-/g, "/");
											var saleDate = new Date(saleTimeStr);

											//如果当期日期大于销售结束日期 xxx
											if(new Date() > saleEndDate) {
												firstCatList[i].goodsList[j].saleStatus = "end";
											} else if(new Date() < saleDate) { //如果当期时间小于上架时间，展示距离开始 时间
												firstCatList[i].goodsList[j].saleStatus = "wait_start";
												var begSeconds = saleDate.getTime() - new Date().getTime(); //时间差的毫秒数        
												//计算出相差天数  
												//  								var days=Math.floor(begSeconds/(24*3600*1000));  
												//计算出小时数  
												var leave1 = begSeconds % (24 * 3600 * 1000); //计算天数后剩余的毫秒数  
												var hours = Math.floor(begSeconds / (3600 * 1000));
												//计算相差分钟数  
												var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数  
												var minutes = Math.floor(leave2 / (60 * 1000));
												//计算相差秒数  
												var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数  
												var seconds = Math.round(leave3 / 1000);
												// 									firstCatList[i].goodsList[j].day=days;
												firstCatList[i].goodsList[j].hour = hours;
												firstCatList[i].goodsList[j].minute = minutes;
												firstCatList[i].goodsList[j].second = seconds;
											} else {
												firstCatList[i].goodsList[j].saleStatus = "on_sale";

												var begSeconds = saleEndDate.getTime() - new Date().getTime(); //时间差的毫秒数        
												//计算出相差天数  
												//  								var days=Math.floor(begSeconds/(24*3600*1000));  
												//计算出小时数  
												var leave1 = begSeconds % (24 * 3600 * 1000); //计算天数后剩余的毫秒数  
												var hours = Math.floor(begSeconds / (3600 * 1000));
												//计算相差分钟数  
												var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数  
												var minutes = Math.floor(leave2 / (60 * 1000));
												//计算相差秒数  
												var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数  
												var seconds = Math.round(leave3 / 1000);
												// 									firstCatList[i].goodsList[j].day=days;
												firstCatList[i].goodsList[j].hour = hours;
												firstCatList[i].goodsList[j].minute = minutes;
												firstCatList[i].goodsList[j].second = seconds;
											}
										}

									}
								}
							}
						}
						that.profixPath = getImgUrl() + "/upload/show.htm?filePath=";
					}
				}, function() {

				});
			},
			getShopIndexAds: function(shopCode) {
				var that = this;
				this.$http.jsonp(getAjaxUrl() + "/shop/ajax_shop_index_ads.htm", {
					params: {
						shopCode: shopCode
					},
					jsonp: 'callback'
				}).then(function(ret) {
					if(ret.body.code == "success") {
						var adsList = ret.body.data.adsList;
						if(adsList != undefined) {
							var sliderItems = new Array();
							for(var i = 0; i < adsList.length; i++) {
								adsList[i].mediaCode = getImgUrl() + "/upload/show.htm?filePath=" + adsList[i].mediaCode;
								if(adsList[i].adsType == "slider") {
									sliderItems.push(adsList[i]);
								} else if(adsList[i].adsType == "banner") {
									that.bannerItem = adsList[i];
								} else if(adsList[i].adsType == "inner_ads") {
									that.adsItem = adsList[i];
								} else if(adsList[i].adsType == "bottom_slogen") {
									that.bottomAdsItem = adsList[i];
								}
							}
							that.sliderItems = sliderItems;
						}
					} else {

					}
				}, function() {

				});
			},
			getShopGoods: function() {
				var that = this;
				var interval = "intervalAll";
				var catCode = "categoryAll";
				var cabinetId = "";
				var pageSize = 8;
				var isQueryAll = "y";
				var currentPage = that.currentPage;
				var orderBy = that.orderBy;
				var orderAsc = that.orderAsc;
				var shopCode = that.shopCode;
				var sortTime = that.sortTime;
				this.$http.jsonp(getAjaxUrl() + "/goods/ajax_goods_list.json", {
					params: {
						cabinetId: cabinetId,
						catCode: catCode,
						interval: interval,
						currentPage: currentPage,
						orderBy: orderBy,
						orderAsc: orderAsc,
						shopCode: shopCode,
						sortTime: sortTime,
						pageSize: pageSize,
						isQueryAll: isQueryAll
					},
					jsonp: 'callback'
				}).then(function(res) {
					if(res.body.code == "success") {
						var goods = res.body.data.goods;
						var totalPage = res.body.data.totalPage;
						that.totalPage = totalPage;
						for(var i = 0; i < goods.length; i++) {
							//商品图片
							var imgMiddle = goods[i].imgMiddle; // 图片
							if(imgMiddle.indexOf(";") != -1) {
								imgMiddle = imgMiddle.split(";")[0];
							}
							imgMiddle = getImgUrl() + "/upload/show.htm?filePath=" + imgMiddle;
							goods[i].imgMiddle = imgMiddle;
							goods[i].unitPrice = goods[i].unitPrice / 100;
						}
						var shopCatList = that.shopCatList;
						for(var i = 0; i < shopCatList.length; i++) {
							var vhtml = "";
							for(var j = 0; j < goods.length; j++) {
								if(goods[j].catCode == shopCatList[i].catCode) {
									vhtml += "<li>";
									vhtml += "<p class='pic tc'>";
									vhtml += "<a href='#goodsDetails?goodsCode=" + goods[j].goodsCode + "'><img src='" + goods[j].imgMiddle + "' width='265' height='265'></a>";
									vhtml += "</p>";
									vhtml += "<p class='title'>";
									vhtml += "<a href='#goodsDetails?goodsCode=" + goods[j].goodsCode + "'>" + goods[j].goodsNameEn + "</a>";
									vhtml += "</p>";
									vhtml += "<p class='other'>";
									vhtml += "<span class='price'>¥" + goods[j].unitPrice + "</span>";
									vhtml += "</p>";
									vhtml += "</li>";
								}
							}
							jQuery("#" + shopCatList[i].catCode).html(vhtml);
						}
					} else {

					}
				}, function() {

				});

			},
			getMore: function(catCode, catNameCn) {
				this.$router.push({
					path: 'goodsClassList',
					query: {
						firstCatCode: catCode,
						catNameCn: catNameCn,
						shopCode: this.shopCode
					}
				});
			},
			getShopCat: function() {
				var that = this;
				var shopCode = that.shopCode;
				var isShow = "y";
				var isLeaf = "y";
				this.$http.jsonp(getAjaxUrl() + "/shop/ajax_shop_cat.json", {
					params: {
						shopCode: shopCode,
						isShow: isShow,
						isLeaf: isLeaf
					},
					jsonp: 'callback'
				}).then(function(res) {
					if(res.body.code == "success") {
						var shopCatList = res.body.data.shopCatList;
						that.shopCatList = shopCatList;
					} else {

					}
				}, function() {

				});

			},
			addOrDeleteFavoriteShop: function() {
				var that = this;
				var shopCode = that.shopCode;
				if(0 == that.isExistFavoriteShop) {
					API.addUserFavorite("shop", null, shopCode, function(ret) {
						if(ret.code != null && ret.code == "success") {
							that.isExistFavoriteShop = 1;
						} else if(ret.code != null && ret.code == "9999") {
							alertConfirm.singleConfirm("请先登录");
						}
					});
				} else if(1 == that.isExistFavoriteShop) {
					API.deleteFavoriteBycode("shop", null, shopCode, function(ret) {
						if(ret.code != null && ret.code == "success") {
							that.isExistFavoriteShop = 0;
						} else {
							alertConfirm.singleConfirm("操作失败");
						}
					});
				}
			},
			existFavoriteShop: function() {
				var that = this;
				var shopCode = that.shopCode;
				API.isExistFavorite("shop", null, shopCode, function(ret) {
					if(ret.code != null && ret.code == "success") {
						that.isExistFavoriteShop = ret.data.isExist;
					} else {
						console.error("existFavorite请求失败：" + ret.msg);
					}
				});
			},
			computeTime: function() {
				var that = this;
				var firstCatList = that.firstCatList;
				for(var i = 0; i < firstCatList.length; i++) {
					if(firstCatList[i].catCode == 'spike') {
						for(var j = 0; j < firstCatList[i].goodsList.length; j++) {
							var saleTimeStr = JSON.parse(firstCatList[i].goodsList[j].attrValue).saleTimeShow;
							var saleEndTimeStr = JSON.parse(firstCatList[i].goodsList[j].attrValue).saleEndTimeShow;

							if(saleEndTimeStr != undefined && saleEndTimeStr != '') {
								saleEndTimeStr = saleEndTimeStr.replace(/-/g, "/");
								var saleEndDate = new Date(saleEndTimeStr);

								saleTimeStr = saleTimeStr.replace(/-/g, "/");
								var saleDate = new Date(saleTimeStr);

								//如果当期日期大于销售结束日期 xxx
								if(new Date() > saleEndDate) {
									firstCatList[i].goodsList[j].saleStatus = "end";
								} else if(new Date() < saleDate) { //如果当期时间小于上架时间，展示距离开始 时间
									firstCatList[i].goodsList[j].saleStatus = "wait_start";
									var begSeconds = saleDate.getTime() - new Date().getTime(); //时间差的毫秒数        
									//计算出相差天数  
									//  								var days=Math.floor(begSeconds/(24*3600*1000));  
									//计算出小时数  
									var leave1 = begSeconds % (24 * 3600 * 1000); //计算天数后剩余的毫秒数  
									var hours = Math.floor(begSeconds / (3600 * 1000));
									//计算相差分钟数  
									var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数  
									var minutes = Math.floor(leave2 / (60 * 1000));
									//计算相差秒数  
									var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数  
									var seconds = Math.round(leave3 / 1000);
									//firstCatList[i].goodsList[j].unitPrice=firstCatList[i].goodsList[j].unitPrice+"1";
									firstCatList[i].goodsList[j].hour = hours;
									firstCatList[i].goodsList[j].minute = minutes;
									firstCatList[i].goodsList[j].second = seconds;
								} else {
									firstCatList[i].goodsList[j].saleStatus = "on_sale";

									var begSeconds = saleEndDate.getTime() - new Date().getTime(); //时间差的毫秒数        
									//计算出相差天数  
									//  								var days=Math.floor(begSeconds/(24*3600*1000));  
									//计算出小时数  
									var leave1 = begSeconds % (24 * 3600 * 1000); //计算天数后剩余的毫秒数  
									var hours = Math.floor(begSeconds / (3600 * 1000));
									//计算相差分钟数  
									var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数  
									var minutes = Math.floor(leave2 / (60 * 1000));
									//计算相差秒数  
									var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数  
									var seconds = Math.round(leave3 / 1000);
									firstCatList[i].goodsList[j].hour = hours;
									firstCatList[i].goodsList[j].minute = minutes;
									firstCatList[i].goodsList[j].second = seconds;
								}
							}
						}
					}
				}
			}
		},
		beforeMount: function() {
			var shopCode = this.$route.query.shopCode;
			if(shopCode != undefined) {
				this.shopCode = shopCode;
			}
			this.getShopIndexAds(shopCode);
			this.existFavoriteShop();
		},
		beforeDestroy() {
			window.clearInterval(this.computeFlag);
		},
		mounted() {
			window.scrollTo(0, 0);
			var shopCode = this.$route.query.shopCode;
			if(shopCode != undefined) {
				this.shopCode = shopCode;
			}
			this.getShopInfo();
			this.getShopCat();

			var that = this;
			this.computeFlag = window.setInterval(function() {
				that.computeTime(); //计算倒计时
			}, 1000);
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
	.more {
		float: right;
		display: block;
		padding: 0 20px;
		height: 24px;
		line-height: 24px;
		background: #fff;
		border: solid 1px #3983c5;
		border-radius: 12px;
		color: #3983c5;
		margin-top: 16px;
	}
	
	.tags li a {
		display: block;
		padding: 0 20px;
		height: 24px;
		line-height: 24px;
		background: #fff;
		border: solid 1px #ddd;
		border-radius: 12px;
	}
	
	.tags li {
		float: left;
		margin-right: 10px;
	}
	
	.tags {
		float: right;
		padding-top: 6px;
		margin-right: 60px;
	}
</style>


// WEBPACK FOOTER //
// src/page/shop/shop_index.vue